import {useState} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { MaterialIcon } from "./UiComponents";

export const yesNoOptions = [
	{ value: "yes", label: "Yes" },
	{ value: "no", label: "No" },
];

export const TextInput = ({ label, name, type = 'text', value, onChange, required, error, classes = '', inputOnly = false}) => {
	const [showPassword, setShowPassword] = useState(false);
	let classesArray = ['form-control'];

	if (classes) {
		classesArray.push(classes);
	}

	if (error) {
		classesArray.push('is-invalid');
	}

	function getType() {
		if (type === 'password' && showPassword) {
			return 'text';
		}

		return type;
	}

	function handleTogglePassword() {
		setShowPassword(!showPassword);
	}

	return (
		<div className="form-group">
			{label && (
				<label htmlFor={name}>{label}{required && '*'}</label>
			)}
			<PasswordInputWrapper show={type === 'password'}>
				<input
					type={getType()}
					name={name}
					className={classesArray.join(' ')}
					value={value}
					onChange={onChange}
					required={required}
				/>
				{type == 'password' && (
					<div className="password-input-wrapper__show-password" onClick={handleTogglePassword}>
						<MaterialIcon icon={showPassword ? 'visibility_off' : 'visibility'} />
					</div>
				)}
			</PasswordInputWrapper>
			{error && <div className="invalid-feedback">{error}</div>}
		</div>
	);
}

const PasswordInputWrapper = ({show, children}) => {

	if (!show) {
		return children
	}

	return (
		<div className="password-input-wrapper">
			{children}
		</div>
	)
}

export const TextArea = ({ label, name, value, onChange, required, error, rows = '5', placeholder = '' }) => {
	let classes = ['form-control'];

	if (error) {
		classes.push('is-invalid');
	}
	return (
		<div className="form-group">
			{label && (
				<label htmlFor={name}>{label}{required && '*'}</label>
			)}
			<textarea
				name={name}
				className={classes.join(' ')}
				value={value}
				onChange={onChange}
				required={required}
				rows={rows}
				placeholder={placeholder}
			/>
			{error && <div className="invalid-feedback">{error}</div>}
		</div>
	);
}

export const Checkbox = ({ label, name, value, onChange, required, error, noMargin, isChecked }) => {
	let classes = ['form-check-input'];

	if (error) {
		classes.push('is-invalid');
	}

	let idString = `${name}_${value}`;

	return (
		<div className={`${!noMargin ? 'form-group' : ''} form-check`}>
			<input
				type="checkbox"
				name={name}
				className={classes.join(' ')}
				value={value}
				onChange={onChange}
				required={required}
				id={idString}
				checked={isChecked}
			/>
			<label htmlFor={idString} className="form-check-label">{label}{(required && !noMargin) && '*'}</label>
			{error && <div className="invalid-feedback">{error}</div>}
		</div>
	);
}

export const RadioButtons = ({ label, name, options, value, onChange, required, error }) => {
	return (
		<div className="form-group radio-buttons-group">
			<label htmlFor="">{label}{required && '*'}</label>
			<div>
				{options.map((option, index) => {
					return (
						<RadioButton
							key={index}
							name={name}
							value={option.value}
							label={option.label}
							checked={value == option.value}
							onChange={onChange}
							required={required}
						/>
					)
				})}
			</div>
			{error && <div className="invalid-feedback">{error}</div>}
		</div>
	)
}

export const RadioButton = ({name, label, value, checked, onChange, required}) => {
	const handleChange = (e) => {
		onChange(e.target.value);
	}

	return (
		<div className="form-check">
			<input className="form-check-input" type="radio" name={name} id={`${name}_${value}`} value={value} checked={checked} onChange={handleChange} required={required} />
			<label className="form-check-label" htmlFor={`${name}_${value}`}>
				{label}
			</label>
		</div>
	)
}

export const StyledRadioButtons = ({ label, name, options, value, onChange, required, error, isPassFail }) => {
	const isInvalid = error && !value ? true : false;
	let outerClasses = ['form-radio-buttons'];
	if (isInvalid) {
		outerClasses.push('is-invalid');
	}
	return (
		<div className="form-group form-radio-buttons-container">
			<label htmlFor="">{label}{required && '*'}</label>
			<div className={outerClasses.join(' ')}>
				{options.map((option, index) => {
					let classes = [];

					if (isPassFail) {
						if (option.value == 1) {
							classes.push('form-radio-button--pass');
						}
						if (option.value == 2) {
							classes.push('form-radio-button--fail');
						}
					}
					return (
						<StyledRadioButton
							key={index}
							name={name}
							value={option.value}
							label={option.label}
							checked={value == option.value}
							onChange={onChange}
							required={required}
							classes={classes.join(' ')}
						/>
					)
				})}
			</div>
			{error && <div className="invalid-feedback">{error}</div>}
		</div>
	)
}

export const StyledRadioButton = ({name, label, value, checked, onChange, required, classes}) => {
	const handleChange = (e) => {
		onChange(e.target.value);
	}

	return (
		<div className={`form-radio-button ${classes}`}>
			<input className="form-radio-button-input" type="radio" name={name} id={`${name}_${value}`} value={value} checked={checked} onChange={handleChange} required={required} />
			<label className="form-radio-button-label" htmlFor={`${name}_${value}`}>
				{label}
			</label>
		</div>
	)
}

export const Checkboxes = ({ label, name, options, value, onChange, required, error }) => {
	return (
		<div className="form-group radio-buttons-group">
			<label htmlFor="">{label}{required && '*'}</label>
			<div>
				{options.map((option, index) => {
					return (
						<Checkbox
							key={index}
							name={name}
							value={option.value}
							label={option.label}
							isChecked={value.includes(option.value)}
							onChange={onChange}
							required={required}
							noMargin={true}
						/>
					)
				})}
			</div>
			{error && <div className="invalid-feedback">{error}</div>}
		</div>
	)
}

export const DatepickerInput = ({ label, name, value, onChange, required, error, format = "dd/MM/yyyy", minDate = null }) => {
	let classes = ['form-control'];

	if (error) {
		classes.push('is-invalid');
	}

	return (
		<div className="form-group">
			<label htmlFor={name}>{label}{required && '*'}</label>
			<div>
			<DatePicker
				name={name}
				className={classes.join(' ')}
				selected={value ?? null}
				onChange={onChange}
				required={required}
				dateFormat={format}
				isClearable
            autoComplete='off'
				minDate={minDate}
			/>
			</div>
			{error && <div className="invalid-feedback">{error}</div>}
		</div>
	);
}

export function SelectInput({ label, name, value, onChange, required, error, options, isMulti = false, placeholder = '', classes = '', clearable = true, containerClasses = '' }) {
	let classesArray = ['dynamic-select'];
	let containerClassesArray = ['form-group'];

	if (classes) {
		classesArray.push(classes);
	}

	if (containerClasses) {
		containerClassesArray.push(containerClasses);
	}

	if (error) {
		classesArray.push('is-invalid');
	}

	return (
		<div className={containerClassesArray.join('')}>
			<label htmlFor={name}>{label}{required && '*'}</label>
			<Select
				name={name}
				className={classesArray.join(' ')}
				value={value}
				onChange={onChange}
				required={required}
				options={options}
				isMulti={isMulti}
				placeholder={placeholder}
				isClearable={clearable}
				classNamePrefix="dynamic-select"
			/>
			{error && <div className="invalid-feedback">{error}</div>}
		</div>
	);
}

export const FormBeforeAfterContent = ({content = null, type= 'before' }) => {
	if (!content) {
		return null;
	}

	// Content will be HTML
	return (
		<div className={`form-before-after-content form-before-after-content--${type}`} dangerouslySetInnerHTML={{__html: content}}></div>
	)
}